import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container } from '@ttstr/components';

const Register: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article className="my-5">
      <Container>
        <Helmet>
          <title>{t(`NEWSLETTER.SUBSCRIBED.TITLE`)}</title>
        </Helmet>
        <h1 className="text-center mb-4">{t(`NEWSLETTER.SUBSCRIBED.TITLE`)}</h1>
        <Row>
          <Col lg={{ size: 6, offset: 3 }}>
            <p className="text-justify newsletter-subscribed-text">
              <p>LEUTE, ÜBERRASCHUNG!</p>

              <p>
                ENNIO x BALI – limitiertes Shirt
                <br />
                Nur 300 Stück. Kein Restock.
              </p>

              <p>
                Du bekommst von mir Zugriff auf die “ENNIO in Bali”-Doku.
                <br />
                Kein Insta. Kein YouTube. Kein Leak. Nur du und ein ehrlicher Blick hinter die Kulissen zum Prozess von
                neuen Songs und Ideen.
              </p>

              <p>
                Was drin ist:
                <br />
                – Frontprint(Kollektion Piece #2)
                <br />
                – Auf 300 Stück limitiert <br />– Zugang zur exklusiven Doku (Code ist im Shirt, so geil haha)
              </p>

              <p>
                DROP:
                <br />
                25.04.2025 – 15:00 Uhr
                <br />
                Online only – wenn weg, dann weg
              </p>

              <p>
                Danke für den Support – das hier geht raus an alle real ones. <br />– euer ENNIO
              </p>
            </p>
          </Col>
        </Row>
      </Container>
    </article>
  );
};

export default React.memo(Register);
